export default "__VITE_ASSET__mp999RZd__"